function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".iconLater_svg__st0{fill:#ffd800}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "iconLater_svg__st0",
  d: "M82.6 144.9c-16.4 0-32.3-5.9-44.9-16.6-12.7-10.8-21-25.8-23.5-42.3-2.8-18.3 1.7-36.6 12.7-51.5C37.9 19.6 54 9.9 72.3 7.1c3.5-.5 7-.8 10.5-.8 16.4 0 32.3 5.9 44.9 16.6 12.7 10.8 21 25.8 23.5 42.3 5.7 37.8-20.3 73.1-58.1 78.9-3.5.5-7 .8-10.5.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.8 12.8c30.5 0 57.2 22.3 62 53.3 5.2 34.3-18.3 66.3-52.6 71.5-3.2.5-6.4.7-9.5.7-30.5 0-57.2-22.3-62-53.3C15.4 50.8 39 18.8 73.3 13.5c3.1-.4 6.3-.7 9.5-.7m0-13c-3.8 0-7.7.3-11.5.9-20 3-37.6 13.7-49.6 30S4.7 67 7.8 87c2.7 18 11.9 34.5 25.7 46.3 13.7 11.7 31.1 18.1 49.1 18.1 3.8 0 7.7-.3 11.5-.9 20-3 37.6-13.7 49.6-30s16.9-36.3 13.9-56.3c-2.7-18-11.9-34.4-25.7-46.3C118.1 6.2 100.7-.2 82.8-.2z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 132.6c.1-2.3.5-4.2 1.2-5.9.6-1.7 1.5-3.1 2.6-4.4 1.1-1.2 2.3-2.4 3.7-3.5 1.3-1.1 2.5-2 3.4-2.8 1-.8 1.8-1.6 2.4-2.3.6-.7 1.1-1.4 1.4-2.1.3-.7.4-1.4.2-2.2-.2-1.2-.6-2-1.4-2.4-.7-.4-1.5-.6-2.4-.5-1.1.2-2 .7-2.6 1.5-.6.8-.7 2.1-.5 3.9L9 113.7c-.2-1.5-.2-3.1.1-4.7.3-1.6 1-3.1 2-4.4 1-1.4 2.5-2.6 4.3-3.6 1.8-1 4.1-1.7 6.9-2.2 1.9-.3 3.7-.3 5.5-.2 1.8.2 3.5.6 5 1.3 1.5.7 2.8 1.8 3.8 3.2 1 1.4 1.7 3.1 2 5.3.2 1.5.2 2.9-.2 4.2s-.9 2.5-1.6 3.7c-.7 1.2-1.6 2.3-2.7 3.3s-2.2 2-3.4 2.9c-1.1.9-2.1 1.7-2.9 2.4-.8.6-1.4 1.3-1.9 1.8-.5.6-.8 1.1-.9 1.6-.2.5-.2 1.1-.1 1.7l16.4-2.5 1.3 8.9-29.6 4.4c-.5-3.2-.7-5.9-.5-8.2zm30.2-35.9L53 95.1l2.3 15.3c.5-1.5 1.5-2.8 2.8-3.9 1.3-1.1 3.1-1.8 5.3-2.2 3.1-.5 5.5 0 7.2 1.4 1.2.9 2.1 2.1 2.7 3.7s1 3.4 1.3 5.4l2.5 16.2-10.3 1.6-2.1-14c-.3-1.7-.7-2.9-1.4-3.7-.7-.8-1.7-1.1-3.1-.9-2.8.4-3.9 2.5-3.3 6.3l2 13.5-10.3 1.6-5.9-38.7z",
  fill: "#0e3935"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "iconLater_svg__SVGID_1_",
  d: "M81.8 133.8l.9-38.9-19.8-12.4-35.3 12.8-7.6-.2-9.5-62.3 116.3-17.7 16 105.5-35.6 5.4z"
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "iconLater_svg__SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#iconLater_svg__SVGID_1_",
  overflow: "visible"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#iconLater_svg__SVGID_2_)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "iconLater_svg__st0",
  cx: 82.7,
  cy: 75.6,
  r: 41.8
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-87.265 82.688 75.582) scale(1.00004)",
  cx: 82.7,
  cy: 75.6,
  r: 41.8,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 9.087,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "0,21.8995"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M83 77.4l-6.4-41.8",
  fill: "none",
  stroke: "#4eb7bc",
  strokeWidth: 12.269,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M101.7 61.5L83 77.4",
  fill: "none",
  stroke: "#0e3935",
  strokeWidth: 12.269,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgIconLater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    id: "iconLater_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 154 154",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgIconLater;